import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

// 이미지 import
import headerSection from "../../../assets/images/Landing_AutoDisplay/headersection.png";
import introIcon1 from "../../../assets/images/Landing_AutoDisplay/introicon1.png";
import introIcon2 from "../../../assets/images/Landing_AutoDisplay/introicon2.png";
import featureSection1 from "../../../assets/images/Landing_AutoDisplay/featuresection1.png";
import featureSection2 from "../../../assets/images/Landing_AutoDisplay/featuresection2.png";
import featureSection3 from "../../../assets/images/Landing_AutoDisplay/featuresection3.png";
import featureSection4 from "../../../assets/images/Landing_AutoDisplay/featuresection4.png";
import serviceLogo from "../../../assets/images/Landing_AutoDisplay/servicelogo.png";
import useCaseSection1 from "../../../assets/images/Landing_AutoDisplay/usecasesection1.png";
import useCaseSection2 from "../../../assets/images/Landing_AutoDisplay/usecasesection2.png";
import useCaseSection3 from "../../../assets/images/Landing_AutoDisplay/usecasesection3.png";
import introSection from "../../../assets/images/Landing_AutoDisplay/introsection.png";

const PageAutodisplayLanding = () => {
  const navigate = useNavigate();
  return (
    <Container>
      {/* 헤더 섹션 */}
      <HeroSection>
        <HeroContent>
          <HeroTextGroup>
            <MainTitle>
              현장의 실시간 정보를 위한
              <br />
              AI 콘텐츠 생성 서비스
            </MainTitle>
            <SubTitle>다양한 정보, 이제는 화면으로 바로 연결하세요</SubTitle>
          </HeroTextGroup>
          <StartButton onClick={() => navigate("/Login")}>
            지금 바로 시작하기
          </StartButton>
        </HeroContent>
        <LogoSection>
          <LogoImage src={serviceLogo} alt="서비스 로고" />
          <LogoText>AutoDisplay</LogoText>
        </LogoSection>
      </HeroSection>

      {/* 기능 소개 섹션 */}
      <FeatureSection>
        <FeatureContainer>
          <FeatureHeader>
            <FeatureMainTitle>
              한 번에 완성하는
              <br />
              현장 맞춤 디스플레이 콘텐츠
            </FeatureMainTitle>
            <FeatureDescription>
              공공 안내부터 실시간 데이터까지
              <br />
              현장에서 필요한 콘텐츠를 AI가 구성해드립니다.
            </FeatureDescription>
          </FeatureHeader>

          {/* 첫 번째 - 기능 설명 (헤더 바로 아래) */}
          <FeatureItemsGrid>
            <FeatureItem>
              <img src={introIcon1} alt="문서기반 콘텐츠 자동화 아이콘" />
              <ItemTextContent>
                <ItemTitle>문서기반 콘텐츠 자동화</ItemTitle>
                <ItemDescription>
                  텍스트나 파일만 넣으면, 안내문 형식으로
                  <br />
                  보기 좋게 정리해서 깔끔한 디스플레이
                  <br />
                  콘텐츠로 AI가 만들어 드려요
                </ItemDescription>
              </ItemTextContent>
            </FeatureItem>
            <FeatureItem>
              <img src={introIcon2} alt="실시간 정보 디스플레이 아이콘" />
              <ItemTextContent>
                <ItemTitle>실시간 정보 디스플레이</ItemTitle>
                <ItemDescription>
                  날씨, 교통, 공공 데이터 등 변화하는 정보를 자동으로 연결해
                  쉽고 빠르게 디스플레이에 보여드려요
                </ItemDescription>
              </ItemTextContent>
            </FeatureItem>
          </FeatureItemsGrid>

          <FeatureGrid>
            {/* 첫 번째 행 - 색상 영역과 정보 */}
            <FeatureRow>
              <FeatureVisual>
                <img src={featureSection1} alt="콘텐츠 생성 자동화" />
              </FeatureVisual>
              <FeatureInfo>
                <InfoBadge>콘텐츠 생성 자동화</InfoBadge>
                <InfoTitle>
                  혼자서도 가능한
                  <br />
                  노코드 콘텐츠 생성
                </InfoTitle>
                <div style={{ marginBottom: "28px" }}></div>
                <InfoDescription>
                  복잡한 협업 과정 없이도
                  <br />
                  AI가 모든 단계를 자동으로 처리합니다.
                </InfoDescription>
              </FeatureInfo>
            </FeatureRow>

            {/* 두 번째 행 */}
            <FeatureRow reverse>
              <FeatureVisual>
                <img src={featureSection2} alt="간편 게시 & 관리" />
              </FeatureVisual>
              <FeatureContent>
                <FeatureInfo>
                  <InfoBadge>간편 게시 & 관리</InfoBadge>
                  <InfoTitle>
                    원하는 디스플레이에
                    <br />
                    코드만 입력하면 게시 완료
                  </InfoTitle>
                  <div style={{ marginBottom: "28px" }}></div>
                  <InfoDescription>
                    코드를 복사해서 원하는 디스플레이에
                    <br />
                    입력하기만 하면 키오스크, 대시보드 등 쉽게
                    <br />
                    게시가 가능합니다.
                  </InfoDescription>
                </FeatureInfo>
              </FeatureContent>
            </FeatureRow>

            {/* 세 번째 행 */}
            <FeatureRow>
              <FeatureVisual>
                <img src={featureSection3} alt="유연한 데이터 연동" />
              </FeatureVisual>
              <FeatureInfo>
                <InfoBadge>유연한 데이터 연동</InfoBadge>
                <InfoTitle>
                  원하는 데이터만 선택하면
                  <br />
                  AI가 바로 연결
                </InfoTitle>
                <div style={{ marginBottom: "28px" }}></div>
                <InfoDescription>
                  날씨 정보, 교통 정보 등 공공 API 까지
                  <br />
                  원하는 데이터를 선택하기만 하면 AI가
                  <br />
                  자동 연동합니다.
                </InfoDescription>
              </FeatureInfo>
            </FeatureRow>

            {/* 네 번째 행 */}
            <FeatureRow reverse>
              <FeatureVisual>
                <img src={featureSection4} alt="내부 데이터 연동" />
              </FeatureVisual>
              <FeatureContent>
                <FeatureInfo>
                  <InfoBadge>내부 데이터 연동</InfoBadge>
                  <InfoTitle>
                    현장 맞춤
                    <br />
                    데이터 커스터마이징
                  </InfoTitle>
                  <div style={{ marginBottom: "28px" }}></div>
                  <InfoDescription>
                    각 부서와 직원들이 자주 확인해야하는
                    <br />
                    센서 정보, 운영 데이터, 작업 지표 등 내부 정보를
                    <br />
                    디스플레이에 맞춤 구성해 보여드려요
                  </InfoDescription>
                </FeatureInfo>
              </FeatureContent>
            </FeatureRow>
          </FeatureGrid>
        </FeatureContainer>
      </FeatureSection>

      {/* 활용 사례 섹션 */}
      <UseCaseSection>
        <SectionContainer>
          <UseCaseContent>
            <UseCaseHeader>
              <SectionBadge>Autodisplay 활용 사례</SectionBadge>
              <div style={{ marginBottom: "12px" }}></div>
              <UseCaseTitle>현장에 필요한 정보, 이렇게 보여주세요</UseCaseTitle>
              <UseCaseDescription>
                고객사의 업무 흐름에 AI 콘텐츠 자동화가 더해지면 어떤 변화가
                생길까요?
              </UseCaseDescription>
            </UseCaseHeader>
            <UseCaseCards>
              <UseCaseCard type="government">
                <CardGradient />
                <CardImage src={useCaseSection1} alt="공무원 공문서 콘텐츠" />
                <CardContent>
                  <CardTitle>
                    문서만 넣으면
                    <br />
                    디스플레이 콘텐츠 완성
                  </CardTitle>
                  <div style={{ marginBottom: "12px" }}></div>
                  <CardCategory>공무원 | 공문서 콘텐츠</CardCategory>
                </CardContent>
              </UseCaseCard>
              <UseCaseCard type="enterprise">
                <CardGradient />
                <CardImage src={useCaseSection2} alt="기업 사내 시스템 공지" />
                <CardContent>
                  <CardTitle>
                    중요한 소식도
                    <br />
                    놓치지 않게 게시
                  </CardTitle>
                  <div style={{ marginBottom: "12px" }}></div>
                  <CardCategory>기업 | 사내 시스템 공지</CardCategory>
                </CardContent>
              </UseCaseCard>
              <UseCaseCard type="factory">
                <CardGradient />
                <CardImage
                  src={useCaseSection3}
                  alt="공장 생산 설비 가동 현황"
                />
                <CardContent>
                  <CardTitle>
                    실시간으로 변하는
                    <br />
                    현장 상황도 지연 없이
                  </CardTitle>
                  <div style={{ marginBottom: "12px" }}></div>
                  <CardCategory>공장 | 생산 설비 가동 현황</CardCategory>
                </CardContent>
              </UseCaseCard>
            </UseCaseCards>
          </UseCaseContent>
        </SectionContainer>
      </UseCaseSection>

      {/* 메인 소개 섹션 */}
      <IntroSection>
        <IntroCard>
          <IntroOverlay />
          <IntroContent>
            <IntroTextGroup>
              <IntroTitle>
                정보 전달의 새로운 방식, Autodisplay로 완성하세요
              </IntroTitle>
              <IntroDescription>
                복잡한 개발 과정과 느린 업데이트는 이제 그만
                <br />
                AI가 모든 정보를 가장 빠르고 정확하며, 생동감 있는 웹 콘텐츠로
                자동화합니다.
              </IntroDescription>
            </IntroTextGroup>
            <ButtonGroup>
              <PrimaryButton onClick={() => navigate("/Login")}>
                바로 시작하기
              </PrimaryButton>
              {/* <SecondaryButton>비즈니스 문의하기</SecondaryButton> */}
            </ButtonGroup>
          </IntroContent>
        </IntroCard>
      </IntroSection>

      {/* 푸터 섹션 */}
      <FooterSection>
        <SectionContainer>
          <FooterWrapper>
            <FooterContent>
              <CompanyInfo>
                <CompanyName>(주) 유저커넥트</CompanyName>
                <CompanyDetails>
                  <DetailRow>
                    <DetailItem>사업자 등록번호: 678 - 81 - 01795</DetailItem>
                    <Divider />
                    <DetailItem>대표자: 박영수</DetailItem>
                  </DetailRow>
                  <DetailRow>
                    <DetailItem>
                      통신판매업신고: 제 2025 - 경기안산 - 0424호
                    </DetailItem>
                    <Divider />
                    <DetailItem>대표전화: 031 - 216 - 5930</DetailItem>
                  </DetailRow>
                  <DetailRow>
                    <DetailItem>고객센터 운영시간: 10:00 ~ 18:00</DetailItem>
                    <Divider />
                    <DetailItem>메일: info@userconnect.kr</DetailItem>
                  </DetailRow>
                  <DetailItem>
                    주소: 경기도 안산시 상록구 해양3로 15, 1512호 ~ 1515호
                    (그랑시티 시그니처타워)
                  </DetailItem>
                  <div style={{ marginBottom: "64px" }}></div>
                </CompanyDetails>
              </CompanyInfo>
              <FooterLogo>AutoDisplay</FooterLogo>
            </FooterContent>
            <Copyright>
              <CopyrightText>Copyright</CopyrightText>
              <CopyrightSymbol>©</CopyrightSymbol>
              <CopyrightText>
                2025 Userconnect Co, Inc All rights reserved.
              </CopyrightText>
            </Copyright>
          </FooterWrapper>
        </SectionContainer>
      </FooterSection>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
`;

const HeroSection = styled.section`
  position: relative;
  width: 100%;
  height: 747px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image: url(${headerSection});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
  }
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  text-align: center;
  color: #fff;
  padding: 0 20px;
`;

const HeroTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const MainTitle = styled.h1`
  font-family: "Pretendard";
  font-weight: 700;
  font-size: 50px;
  line-height: 1.4em;
  letter-spacing: -3%;
  text-align: center;
  color: #ffffff;
  margin: 0;
`;

const SubTitle = styled.p`
  font-family: "Pretendard";
  font-weight: 500;
  font-size: 24px;
  line-height: 1.55em;
  letter-spacing: -3%;
  text-align: center;
  color: #ffffff;
  margin: 0;
`;

const StartButton = styled.button`
  background: #256ef4;
  border: none;
  border-radius: 48px;
  padding: 12px 32px;
  font-family: "Pretendard";
  font-weight: 600;
  font-size: 24px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
  line-height: 1.55em;

  &:hover {
    background: #1e5dc7;
    transform: translateY(-2px);
  }
`;

const LogoSection = styled.div`
  position: absolute;
  top: 37px;
  left: 84px;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const LogoImage = styled.img`
  width: 40px;
  height: 40px;
`;

const LogoText = styled.span`
  font-family: "Pretendard";
  font-weight: 600;
  font-size: 28px;
  color: #ffffff;
`;

const IntroSection = styled.section`
  width: 100%;
  padding: 120px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const IntroCard = styled.div`
  width: 1054px;
  height: 500px;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  background-image: url(${introSection});
  background-size: cover;
  background-position: center;
`;

const IntroOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.5;
  background: black;
  border-radius: 20px;
`;

const IntroContent = styled.div`
  position: absolute;
  left: 100px;
  top: 120px;
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 60px;
`;

const IntroTextGroup = styled.div`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  display: flex;
`;

const IntroTitle = styled.h2`
  text-align: left;
  color: white;
  font-size: 40px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 62px;
  word-wrap: break-word;
  margin: 0;
`;

const IntroDescription = styled.p`
  text-align: left;
  color: #f0f0f0;
  font-size: 24px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 37.2px;
  word-wrap: break-word;
  margin: 0;
`;

const ButtonGroup = styled.div`
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  display: inline-flex;
`;

const PrimaryButton = styled.button`
  width: 236px;
  min-width: 98px;
  padding: 12px 32px;
  background: white;
  border: none;
  border-radius: 48px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: flex;
  color: #1F1F1F;
  font-size: 24px;
  font-family: Pretendard;
  font-weight: 600;
  line-height: 36px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #f0f0f0;
    transform: translateY(-2px);
  }
`;

const SecondaryButton = styled.button`
  width: 236px;
  min-width: 98px;
  padding: 12px 32px;
  background: #256ef4;
  border: none;
  border-radius: 48px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: flex;
  color: white;
  font-size: 24px;
  font-family: Pretendard;
  font-weight: 600;
  line-height: 36px;
  cursor: pointer;
  line-height: 1.5em;
  transition: all 0.3s ease;

  &:hover {
    background: #1e5dc7;
    transform: translateY(-2px);
  }
`;

const UseCaseSection = styled.section`
  width: 100%;
  padding: 120px 193px;
  background: #faf9ff;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;

const UseCaseHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 4px;
`;

const UseCaseTitle = styled.h2`
  text-align: left;
  color: #1F1F1F;
  font-family: Pretendard;
  font-size: 40px;
  font-weight: 700;
  line-height: 62px;
  margin: 0;
`;

const UseCaseDescription = styled.p`
  text-align: left;
  color: #1F1F1F;
  font-family: Pretendard;
  font-size: 24px;
  font-weight: 500;
  line-height: 37px;
  margin: 0;
`;

const SectionBadge = styled.div`
  background: #cfdefc;
  color: #1F1F1F;
  opacity: 0.9;
  padding: 8px 24px;
  border-radius: 100px;
  font-family: "Pretendard", sans-serif;
  font-weight: 600;
  font-size: 22px;
  width: fit-content;
`;

const UseCaseCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  width: 100%;
`;

const UseCaseCard = styled.div`
  position: relative;
  width: 316px;
  height: 364px;
  border-radius: 12.118343353271484px;
  overflow: hidden;
`;

const CardGradient = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.65));
  z-index: 2;
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

const CardContent = styled.div`
  position: relative;
  z-index: 3;
  padding: 36px;
  color: #fff;
  text-align: left;
`;

const CardCategory = styled.p`
  font-family: "Pretendard", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.55em;
  letter-spacing: -3%;
  color: #f0f0f0;
  margin: 0;
`;

const CardTitle = styled.h3`
  font-family: "Pretendard", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.55em;
  letter-spacing: -3%;
  color: #ffffff;
  margin: 0;
`;

const FeatureSection = styled.section`
  width: 100%;
  padding: 124px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 100px;
`;

const FeatureContainer = styled.div`
  max-width: 1054px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 100px;
`;

const SectionContainer = styled.div`
  max-width: 1054px;
  width: 100%;
  margin: 0 auto;
`;

const UseCaseContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;
`;

const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const FeatureHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 468px;
`;

const FeatureMainTitle = styled.h2`
  font-family: "Pretendard";
  font-weight: 700;
  font-size: 40px;
  line-height: 1.4em;
  letter-spacing: -3%;
  text-align: center;
  color: #1F1F1F;
  margin: 0;
`;

const FeatureDescription = styled.p`
  font-family: "Pretendard";
  font-weight: 500;
  font-size: 24px;
  line-height: 1.55em;
  letter-spacing: -3%;
  text-align: center;
  color: #666666;
  margin: 0;
`;

const FeatureGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 200px;
  width: 100%;
`;

const FeatureRow = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  ${(props) => props.reverse && "flex-direction: row-reverse;"}
`;

const FeatureContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 480.34px;
`;

const FeatureItemsGrid = styled.div`
  display: grid;
  grid-template-columns: 480px 480px;
  gap: 40px;
  justify-content: start;
  width: 100%;
  margin-bottom: 100px;
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;

  img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
`;

const ItemTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

const ItemIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 6px;
  background: ${(props) => {
    switch (props.type) {
      case "document":
        return "#06D5AC";
      case "realtime":
        return "#4586FF";
      default:
        return "#f0f0f0";
    }
  }};
`;

const ItemTitle = styled.h3`
  font-family: "Pretendard";
  font-weight: 600;
  font-size: 30px;
  line-height: 1.55em;
  letter-spacing: -3%;
  color: #1F1F1F;
  margin: 0;
  text-align: left;
`;

const ItemDescription = styled.p`
  font-family: "Pretendard";
  font-weight: 500;
  font-size: 24px;
  line-height: 1.55em;
  letter-spacing: -3%;
  color: #666666;
  margin: 0;
  text-align: left;
`;

const FeatureVisual = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    max-width: 480px;
    height: auto;
    object-fit: contain;
  }
`;

const ContentPreview = styled.div`
  width: 100%;
  height: 100%;
  background: ${(props) => {
    switch (props.type) {
      case "automation":
        return "#EEEBFF";
      case "management":
        return "#EBF8FF";
      case "data":
        return "#CFECE1";
      case "internal":
        return "#DBE5FF";
      default:
        return "#f0f0f0";
    }
  }};
`;

const FeatureInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 510px;
`;

const InfoBadge = styled.div`
  align-self: stretch;
  opacity: 0.9;
  justify-content: center;
  color: #2563eb;
  font-size: 20px;
  font-weight: 500;
  font-family: "Pretendard";
  line-height: 1.75;
  text-align: left;
  width: fit-content;
`;

const InfoTitle = styled.h3`
  font-family: "Pretendard";
  font-weight: 600;
  font-size: 32px;
  line-height: 1.55em;
  letter-spacing: -3%;
  color: #1F1F1F;
  margin: 0;
  text-align: left;
`;

const InfoDescription = styled.p`
  font-family: "Pretendard";
  font-weight: 500;
  font-size: 24px;
  line-height: 1.55em;
  letter-spacing: -3%;
  color: #666666;
  margin: 0;
  text-align: left;
`;

const FooterSection = styled.section`
  width: 100%;
  padding: 160px 0 120px 0;
  background: #f6f6f6;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const CompanyName = styled.h3`
  font-family: "Pretendard";
  font-weight: 600;
  font-size: 16px;
  color: #1F1F1F;
  margin: 0;
  text-align: left;
`;

const CompanyDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DetailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DetailItem = styled.span`
  font-family: "Pretendard";
  font-size: 14px;
  color: #1F1F1F;
`;

const Divider = styled.span`
  width: 1px;
  height: 12px;
  background: #dddddd;
`;

const FooterLogo = styled.span`
  font-family: "Pretendard";
  font-size: 36px;
  color: #1F1F1F;
  font-weight: 600;
  margin-top: 88px;
`;

const Copyright = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CopyrightText = styled.span`
  font-family: "Pretendard";
  font-size: 16px;
  color: #1F1F1F;
  font-weight: 500;
`;

const CopyrightSymbol = styled.span`
  font-family: "Pretendard";
  font-size: 16px;
  color: #1F1F1F;
  font-weight: 500;
`;

export default PageAutodisplayLanding;
